import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import {
  getTeacherIndexGrid,
  updateTeacherIndexGrid,
} from "../../../store/structure/actions";
import { connect } from "react-redux";
import { Skeleton } from "@mui/material";

const TeacherIndexGrid = (props) => {
  useEffect(() => {
    document.title = "IPPIS - Org. Structure | Teacher Index Grid";
  });

  const {
    teacherIndexGrid,
    getTeacherIndexGrid,
    updateTeacherIndexGrid,
    loading,
    onWait,
  } = props;

  const [hoveredIndexValue, sethoveredIndexValue] = useState(null);
  const theme = useTheme();

  useEffect(() => {
    if (!teacherIndexGrid) getTeacherIndexGrid();
  }, []);

  return (
    <div
      className="px-4 fixTableHead"
      style={{
        backgroundColor: "#fff",
        borderRadius: "0.5rem",
        boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
        MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
        height: "74vh",
        width: "100vw",
        margin: "0px",
        overflowX: "auto",
      }}
    >
      {loading && !onWait && (
        <div className="container mt-2" style={{ width: "100%" }}>
          <Skeleton />
          <Skeleton animation="wave" />
          <Skeleton />
          <Skeleton animation={false} />
          <Skeleton animation="wave" />
        </div>
      )}

      {teacherIndexGrid &&
        (!loading || onWait) &&
        !!teacherIndexGrid?.columns?.length && (
          <table className=" tablex table-bordered fixTableHead">
            <thead>
              <tr>
                {teacherIndexGrid.columns.map((column, index) => (
                  <React.Fragment key={index}>
                    {index > 1 && (
                      <th
                        className="pr-2"
                        style={{ textAlign: "right", minWidth: "84px" }}
                      >
                        {column === "isActive"
                          ? "ACTIVE"
                          : column === "role"
                          ? "ROLE"
                          : column === "qualification"
                          ? "QUALIFICATION"
                          : column.toUpperCase()}
                      </th>
                    )}
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {teacherIndexGrid &&
                teacherIndexGrid.rows.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={
                      hoveredIndexValue &&
                      !["role", "qualification"].includes(
                        hoveredIndexValue.column
                      ) &&
                      hoveredIndexValue.rowIndex === rowIndex
                        ? "hovered-row"
                        : ""
                    }
                  >
                    {teacherIndexGrid.columns.map((column, colIndex) => (
                      <React.Fragment key={colIndex}>
                        {colIndex > 1 && (
                          <>
                            {colIndex === 2 ? (
                              <td
                                className="pr-2"
                                style={{ textAlign: "right" }}
                              >
                                {row["role"]}_{row["qualification"]}
                              </td>
                            ) : (
                              <td
                                style={{
                                  textAlign: "right",
                                  backgroundColor:
                                    ![
                                      "role",
                                      "qualification",
                                      "isActive",
                                    ].includes(column) && !row[column]
                                      ? "#fffa0070"
                                      : "inherit",
                                }}
                                onMouseOver={() => {
                                  const role = row[teacherIndexGrid.columns[0]];
                                  const qualification =
                                    row[teacherIndexGrid.columns[1]];
                                  sethoveredIndexValue({
                                    role,
                                    qualification,
                                    column,
                                    rowIndex,
                                    colIndex,
                                  });
                                }}
                                onMouseLeave={() => sethoveredIndexValue(null)}
                                className={
                                  hoveredIndexValue &&
                                  !["role", "qualification"].includes(
                                    hoveredIndexValue.column
                                  ) &&
                                  hoveredIndexValue.rowIndex === rowIndex &&
                                  hoveredIndexValue.colIndex === colIndex &&
                                  !(column === "isActive")
                                    ? "hovered-td-box"
                                    : hoveredIndexValue &&
                                      !["role", "qualification"].includes(
                                        hoveredIndexValue.column
                                      ) &&
                                      // !!row[column] &&
                                      hoveredIndexValue.colIndex === colIndex
                                    ? "hovered-td"
                                    : ""
                                }
                              >
                                {hoveredIndexValue &&
                                !["role", "qualification"].includes(
                                  hoveredIndexValue.column
                                ) &&
                                hoveredIndexValue.rowIndex === rowIndex &&
                                hoveredIndexValue.colIndex === colIndex ? (
                                  <GridInput
                                    role={
                                      hoveredIndexValue &&
                                      hoveredIndexValue.role
                                    }
                                    qualification={
                                      hoveredIndexValue &&
                                      hoveredIndexValue.qualification
                                    }
                                    column={column}
                                    colIndex={colIndex}
                                    rowIndex={rowIndex}
                                    row={row}
                                    updateTeacherIndexGrid={
                                      updateTeacherIndexGrid
                                    }
                                  />
                                ) : column === "isActive" ? (
                                  <GridInput
                                    role={
                                      hoveredIndexValue &&
                                      hoveredIndexValue.role
                                    }
                                    qualification={
                                      hoveredIndexValue &&
                                      hoveredIndexValue.qualification
                                    }
                                    column={column}
                                    colIndex={colIndex}
                                    rowIndex={rowIndex}
                                    row={row}
                                    updateTeacherIndexGrid={
                                      updateTeacherIndexGrid
                                    }
                                  />
                                ) : (
                                  <React.Fragment>
                                    <span className="align-level-centered">
                                      {row[column]}
                                    </span>
                                  </React.Fragment>
                                )}
                              </td>
                            )}
                          </>
                        )}
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
            </tbody>
          </table>
        )}
    </div>
  );
};

const mapStateToProps = ({ loading, onWait, teacherIndexGrid }) => {
  return { loading, onWait, teacherIndexGrid };
};
export default connect(mapStateToProps, {
  getTeacherIndexGrid,
  updateTeacherIndexGrid,
})(TeacherIndexGrid);

const GridInput = (props) => {
  const { id, column, colIndex, rowIndex, row, updateTeacherIndexGrid } = props;
  const [value, setValue] = useState(row[column] ? row[column] : "");
  const [valueBoolen, setValueBoolen] = useState(row[column] ? true : false);

  const onSaveChanges = (level, scale, value, type) => {
    if (type === "checkbox") {
      value = value ? 1 : 0;

      updateTeacherIndexGrid(id, scale, value, type, setValueBoolen);
    }
    if (type === "number") {
      value = value ? parseInt(value) : null;

      updateTeacherIndexGrid(id, scale, value, type, setValue);
    }
  };

  return (
    <>
      {column === "isActive" ? (
        <input
          // disabled
          type="checkbox"
          name={column + "-" + colIndex + "-" + rowIndex}
          // onBlur={() => console.log("Saved")}
          value={valueBoolen}
          checked={valueBoolen ? "checked" : ""}
          // onChange={(e) => {
          //   const value = !valueBoolen;

          //   row[column] = value;

          //   onSaveChanges(level, column, value, "checkbox");
          // }}
        />
      ) : (
        <input
          readOnly
          type="text"
          name={column + "-" + colIndex + "-" + rowIndex}
          // onKeyPress={(e) =>
          //   e.key === "Enter" && onSaveChanges(level, column, value, "number")
          // }

          value={value}
          // onChange={(e) => {
          //   const value = e.target.value || "";
          //   row[column] = value;
          //   setValue(value);
          // }}
        />
      )}
    </>
  );
};
